import {
  ProviderStripeStatus,
  SetStripeAccountEmailAction,
  SetStripeStatusAction,
} from './types';

export const enum PaymentIntegrationsActionType {
  setStripeStatus = 'PAYMENT_INTEGRATIONS/SET_STRIPE_STATUS',
  setStripeAccountEmail = 'PAYMENT_INTEGRATIONS/SET_STRIPE_ACCOUNT_EMAIL',
}

export const setStripeStatus = (
  stripeStatus: ProviderStripeStatus
): SetStripeStatusAction => ({
  type: PaymentIntegrationsActionType.setStripeStatus,
  payload: stripeStatus,
});

export const setStripeAccountEmail = (
  accountEmail: string
): SetStripeAccountEmailAction => ({
  type: PaymentIntegrationsActionType.setStripeAccountEmail,
  payload: accountEmail,
});
